<template>
  <v-row justify="space-between" align="center" class="evaluation-header">
    <v-col cols="12" sm="12" md="4" lg="4" class="d-flex align-center">
      <!-- 
      <img
        class="evaluation-header__page-icon"
        src="@/assets/icons/online-course.svg"
        alt
      />
      -->
      <h1 class="titulo-2 color-purpura-base">
        {{ title }}
      </h1>
    </v-col>
    <v-col cols="12">
      <EvaluationFilter />
    </v-col>
    <!-- <v-col cols="12" sm="12" md="4" lg="4">
      <EvaluationSortFilter />
    </v-col> -->
  </v-row>
</template>

<script>
import EvaluationFilter from "@/components/evaluations/EvaluationFilter";
// import EvaluationSortFilter from "@/components/evaluations/EvaluationSortFilter";
export default {
  props: {
    title: {
      type: String,
    },
  },
  components: {
    EvaluationFilter,
  },
};
</script>

<style lang="scss">
@import '../../assets/styles/generals.scss';


.evaluation-header {
  position: relative;


  &__title{
    color: #72237c;
    font-size: 26px ;
  }
}

</style>
